import { FETCH_PAGINATED_RECIPES, FETCH_ALL_RECIPES, RECIPE_QUERY } from '../../mutation-types';

export default {
  [FETCH_PAGINATED_RECIPES](state, { recipes, pagination }) {
    state.items = recipes;
    state.pagination = pagination;
  },

  [FETCH_ALL_RECIPES](state, recipe) {
    state.all = recipe;
  },

  [RECIPE_QUERY](state, { page, limit, search }) {
    state.query.page = page;
    state.query.limit = limit;
    state.query.search = search;
    state.query.isSet = true;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/recipe/mutations.js